export const STACK_CACHE_ADD = 'STACK_CACHE_ADD';